import { render, staticRenderFns } from "./ProjectValuationExternalReportPage10.vue?vue&type=template&id=99ef5aa2&scoped=true&"
import script from "./ProjectValuationExternalReportPage10.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationExternalReportPage10.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectValuationExternalReportPage10.vue?vue&type=style&index=0&id=99ef5aa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ef5aa2",
  null
  
)

export default component.exports